class RGBWorldHeader {
  constructor(root) {
    this.root = root;
    this.menu = root.querySelector('[data-rgb-header-menu]');
    this.opener = root.querySelector('[data-rgb-header-menu-open]');
    this.abort = new AbortController();
    this.bind();
    window.RGBPreservePreviewLinks?.(this.root);
    this.bindCart();
    this.onScroll();
  }

  bind() {
    const signal = this.abort.signal;
    this.opener?.addEventListener('click', this.openMenu, { signal });
    this.root.querySelector('[data-rgb-header-menu-close]')?.addEventListener('click', this.closeMenu, { signal });
    this.menu?.addEventListener('cancel', this.onCancel, { signal });
    this.menu?.addEventListener('keydown', this.trapFocus, { signal });
    this.menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', this.closeMenu, { signal }));
    this.root.querySelectorAll('[data-rgb-header-cart]').forEach((link) => link.addEventListener('click', this.onCartClick, { signal }));
    document.addEventListener('click', this.closeBeforeOverlay, { capture: true, signal });
    addEventListener('scroll', this.onScroll, { passive: true, signal });
  }

  async bindCart() {
    const { StandardEvents } = await import('@shopify/events');
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, { signal: this.abort.signal });
  }

  onCartUpdate = (event) => {
    event.promise?.then(({ cart }) => {
      const count = cart?.totalQuantity;
      if (count === undefined) return;
      this.root.querySelectorAll('[data-rgb-header-cart-count]').forEach((node) => { node.textContent = String(count); });
    }).catch((error) => { if (error?.name !== 'AbortError') console.warn('[rgb-header] Cart update failed', error); });
  };

  onCartClick = (event) => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (!(trigger instanceof HTMLElement) || trigger.getClientRects().length === 0) return;
    event.preventDefault();
    this.closeMenu();
    trigger.click();
  };

  openMenu = () => {
    if (!this.menu || this.menu.open) return;
    document.documentElement.classList.add('rgb-wrld-menu-open');
    this.menu.showModal();
    this.menu.querySelector('[data-rgb-header-menu-close]')?.focus();
  };

  closeMenu = () => {
    if (!this.menu?.open) return;
    this.menu.close();
    document.documentElement.classList.remove('rgb-wrld-menu-open');
    this.opener?.focus();
  };

  closeBeforeOverlay = (event) => {
    if (!event.target.closest('[data-rgb-room-trigger],[data-rgb-styling-entry],[data-rgb-review-open]')) return;
    this.closeMenu();
  };

  onCancel = (event) => { event.preventDefault(); this.closeMenu(); };

  trapFocus = (event) => {
    if (event.key === 'Escape') { event.preventDefault(); this.closeMenu(); return; }
    if (event.key !== 'Tab' || !this.menu) return;
    const focusable = [...this.menu.querySelectorAll('button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])')].filter((item) => item instanceof HTMLElement && !item.hidden);
    if (!focusable.length) return;
    const first = focusable[0]; const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  onScroll = () => { this.root.classList.toggle('is-scrolled', scrollY > 24); };

  destroy() {
    this.abort.abort();
    if (this.menu?.open) this.menu.close();
    document.documentElement.classList.remove('rgb-wrld-menu-open');
  }
}

function initRGBWorldHeader(scope = document) {
  scope.querySelectorAll('[data-rgb-world-header]').forEach((root) => {
    if (!root.rgbWorldHeader) root.rgbWorldHeader = new RGBWorldHeader(root);
  });
}

initRGBWorldHeader();
document.addEventListener('shopify:section:load', (event) => initRGBWorldHeader(event.target));
document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('[data-rgb-world-header]')?.rgbWorldHeader?.destroy());
